import _toConsumableArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import countriesA from './countriesA';
import countriesB from './countriesB';
import countriesC from './countriesC';
import countriesD from './countriesD';
var countries = [].concat(_toConsumableArray(countriesA), _toConsumableArray(countriesB), _toConsumableArray(countriesC), _toConsumableArray(countriesD));
export default countries;